var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
var BackArrow = React.forwardRef(function (props, ref) { return (_jsx("svg", __assign({ ref: ref }, props, { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M8.81673 3.87479L2.9834 9.70812C2.81673 9.87479 2.81673 10.1331 2.9834 10.2998L8.81673 16.1331C8.9834 16.2998 9.24173 16.2998 9.4084 16.1331L10.0001 15.5415C10.1667 15.3748 10.1667 15.1165 10.0001 14.9498L5.8834 10.8331L16.2501 10.8331C16.4834 10.8331 16.6667 10.6498 16.6667 10.4165V9.58312C16.6667 9.34979 16.4834 9.16646 16.2501 9.16646L5.87507 9.16646L9.99173 5.04979C10.1584 4.88312 10.1584 4.62479 9.99173 4.45812L9.40006 3.86646C9.2334 3.69979 8.97506 3.69979 8.8084 3.86646L8.81673 3.87479Z", fill: "#2B3737" }) }))); });
export default BackArrow;
